import React from 'react';

import ButtonWithIcon, {
    ButtonWithIconProps,
} from 'components/Buttons/ButtonWithIcon/ButtonWithIcon';

import closeIcon from '@yandex-data-ui/common/assets/icons/preview-close.svg';

export type CloseButtonProps = Omit<ButtonWithIconProps, 'icon' | 'size' | 'iconSize' | 'theme'>;

const CloseButton: React.FC<CloseButtonProps> = (props) => (
    <ButtonWithIcon {...props} icon={closeIcon} size="xs" iconSize={16} theme="accent" />
);

export default CloseButton;
